var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.998H11",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.998H11",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66665 11.9987H1.66665C0.931178 11.9965 0.33551 11.4008 0.333313 10.6654V6.66536C0.33551 5.9299 0.931178 5.33423 1.66665 5.33203H14.3333C15.0688 5.33423 15.6645 5.9299 15.6666 6.66536V10.6654C15.6645 11.4008 15.0688 11.9965 14.3333 11.9987H12.3333",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 3.9987V1.33203H10.0573C10.2341 1.33207 10.4036 1.40233 10.5286 1.52736L12.138 3.1367C12.263 3.26169 12.3333 3.43123 12.3333 3.60803V3.9987",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 16C12.3333 16.3682 12.0348 16.6667 11.6666 16.6667H4.33329C3.9651 16.6667 3.66663 16.3682 3.66663 16V10H12.3333V16Z",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33329 7.99935C2.70148 7.99935 2.99996 7.70087 2.99996 7.33268C2.99996 6.96449 2.70148 6.66602 2.33329 6.66602C1.9651 6.66602 1.66663 6.96449 1.66663 7.33268C1.66663 7.70087 1.9651 7.99935 2.33329 7.99935Z",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66663 1.33203V3.9987H12.3333",
    stroke: "#086EA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.c2aab6a0a93a22eddb758511ef46c7f6.svg";
export { ForwardRef as ReactComponent };